// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fm-answer img,\n.fm-question img {\n  max-width: 100%;\n  height: auto !important;\n}", ""]);
// Exports
module.exports = exports;
